"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { Time_Entries } from "@/src/gql/graphql";

/** "Approval Status" card — a colored dot + Approved / Pending Approval label. */
export function ApprovalStatusSection({ item }: { item: Time_Entries }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Approval Status</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-4">
          {item.is_approved ? (
            <>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                <span className="text-sm font-medium text-card-foreground">Approved</span>
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                <span className="text-sm font-medium text-card-foreground">Pending Approval</span>
              </div>
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
